import store from '../../store';
import history from '../../utils/history';
import { setMetricsEvent } from '../../actions/metrics';
import {
    METRIC_EVENT,
    METRIC_CATEGORY_TOPMENU,
    METRIC_ACTION_CLICK,
    METRIC_LABEL_ADMINPROFILE,
    METRIC_LABEL_VIEWPROFILE
} from '../../components/Profile/constants';
import { stopPlayer } from '../../AAF/Resilence/main'; 
import { setProfileData } from '../../reducers/profile';
import { receiveIsLoggedIn } from '../../reducers/user';
import { fetchLinealChannels } from '../../actions/payway';
import { login } from '../../requests/loader';
import Utils from '../../utils/Utils';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import utilsIsSticky from '../../utils/user/IsSticky';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import NewRelic from '../../utils/trackers/NewRelic';
import BlockedChannels from '../../utils/BlockedChannels';
import channelBlockedUtil from '../../utils/ChannelBlockedUtil';
import { doLogout } from '../../components/Modal/ModalProfile';
import { CONFIG_TYPES } from './configTypes';

const sendMetric = (label) => {
    store.dispatch(setMetricsEvent({
        hitType: METRIC_EVENT,
        eventCategory: METRIC_CATEGORY_TOPMENU,
        eventAction: METRIC_ACTION_CLICK,
        eventLabel: label
    }));
    store.dispatch(setMetricsEvent({ type: 'executor' }));
};

export const profileSettingsHandler = () => {
    const path = '/user-settings/idioma';
    history.push(path);
}

export const profileHandler = async (profile) => {
    stopPlayer();
    store.dispatch(
        setProfileData({
            profile
        })
    );
    const userhash = profile.user_hash;
    sendMetric(METRIC_LABEL_VIEWPROFILE);

    try {
        const element = document.getElementsByClassName('app-profile-none');
        if (element[0]) element[0].style.display = 'block';
        const response = await login({
            userhash,
            includpaywayprofile: 'true'
        });

        if (response && response.response && (response.status === '0' || response.status === 200)) {
            await profileLoginSuccess(response.response);
            Utils.setCustomAttribute();
        }
    } catch (error) {
        console.error('Error al iniciar sesión con el perfil seleccionado', error);
    }
};

const profileLoginSuccess = async (response) => {
    store.dispatch(receiveIsLoggedIn(response));
    const pushSession = Utils.getApaMetadataKey(
        'sticky_session',
        '{"push_session":false,"user_id":false}',
        'push_session'
    );

    if (pushSession) {
        await utilsIsSticky.getPushSession(profileStickySuccess, response);
    } else {
        profileStickySuccess(null, response);
    }
};

const profileStickySuccess = async (stickyResponse, response) => {
    DeviceStorage.setItem('user_hash', response.session_userhash);

    if (response.user_id) {
        DeviceStorage.setItem('user_id', response.user_id);
        NewRelic.setUserId(response.user_id);
    }

    await updateBlockedChannels();
    new ChannelSingleton().checkLinealChannels(() => {
        history.push('/');
    });
};

const updateBlockedChannels = async () => {
    const blockedChannelsList = new BlockedChannels();
    const response = await blockedChannelsList.checkBlockedChannels();
    channelBlockedUtil.set('blockedChannels', response);
};

export const logoutHandler = () => {
    doLogout();
}

export const aboutHandler = () => {
    const path = '/about';
    history.push(path);
};

export const refreshSessionHandler = async () => {
    const user = store.getState().user;
    const userhash = DeviceStorage.getItem('user_hash');

    if (!user || !user.email || !userhash) return;

    try {
        const response = await login({ userhash });

        if (response && response.response && response.status === '0') {
            store.dispatch(fetchLinealChannels(response.response.user_id));
            store.dispatch(receiveIsLoggedIn(response.response));
            DeviceStorage.setItem('user_hash', response.response.session_userhash);

            stopPlayer();

            const region = DeviceStorage.getItem('region');
            if (region !== response.response.region) {
                DeviceStorage.setItem('region', response.response.region);
                window.location.href = '/';
            } else {
                history.push('/');
            }
        }
    } catch (error) {
        console.error('Error al actualizar la sesión', error);
    }
};


export const mySubscriptionsHandler = () => {
   history.push(`config/${CONFIG_TYPES.MY_SUBSCRIPTIONS}`);
}

export const seeProfilesHandler = () => {
    history.push('/profile');
};


// WEBPACK FOOTER //
// ./src/containers/config/utils.js